"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBreakpointFromClass = void 0;
const getBreakpointFromClass = (css) => {
    let breakpoint = 'A';
    if (css.includes('not-size-a')) {
        breakpoint = 'B';
        if (css.includes('not-size-b')) {
            breakpoint = 'C';
            if (css.includes('not-size-c')) {
                breakpoint = 'D';
            }
        }
    }
    return breakpoint;
};
exports.getBreakpointFromClass = getBreakpointFromClass;
//# sourceMappingURL=index.js.map